import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { CardView } from '@forbiz/web-kit'
import type { PublicCardResponse } from '@forbiz/contracts'

import s from './CardPage.module.css'

/**
 * 수신자 디지털 화환 카드 (BIZ-86) — 공개 페이지(무인증).
 * 수신자(상주 등)가 배송완료 알림의 링크로 연다. 이 화면이 제품의 감동 핵심.
 *
 * 카드 프레임(PAPER/NIGHT) 렌더는 공유 컴포넌트 CardView(@forbiz/web-kit)가 그린다 —
 * admin 스킨 미리보기(BIZ-115)와 같은 렌더러라 미리보기가 실제 카드와 어긋나지 않는다.
 * 이 페이지는 토큰 fetch·수신자 답문(BIZ-113)만 담당한다.
 */

export function CardPage() {
  const { token } = useParams<{ token: string }>()
  const [card, setCard] = useState<PublicCardResponse | null>(null)
  const [state, setState] = useState<'loading' | 'ok' | 'missing'>('loading')

  useEffect(() => {
    let alive = true
    // 공개 엔드포인트 — 세션 없이 fetch로 직접 부른다(api 클라이언트의 401 처리와 무관하게).
    fetch(`/api/cards/${token}`)
      .then(async (res) => {
        if (!alive) return
        if (!res.ok) return setState('missing')
        setCard((await res.json()) as PublicCardResponse)
        setState('ok')
      })
      .catch(() => {
        if (alive) setState('missing')
      })
    return () => {
      alive = false
    }
  }, [token])

  useEffect(() => {
    document.title = card ? '마음이 도착했습니다 — 포비즈' : '포비즈'
  }, [card])

  if (state === 'loading') return <div className={s.holder} />
  if (state === 'missing' || !card) {
    return (
      <div className={s.holder}>
        <p className={s.missing}>카드를 찾을 수 없습니다.<br />링크가 정확한지 확인해 주세요.</p>
      </div>
    )
  }

  return (
    <CardView
      occasionType={card.occasionType}
      frame={card.frame}
      bgColor={card.skin.bgColor}
      textColor={card.skin.textColor}
      accentColor={card.skin.accentColor}
      bgImageUrl={card.skin.bgImageUrl}
      textPosition={card.skin.textPosition}
      headline={card.headline}
      message={card.message}
      senderName={card.senderName}
    />
  )
}
